export const validateLink = /\..{2,}$/;

export const validateHexadecimalCode = /^#?([a-f0-9]{6}|[a-f0-9]{3})$/;
